import { createAction, props } from '@ngrx/store';
import { LocationInterfaceWithId } from '@sk/sk-interfaces';

export const loadLocations = createAction('[Locations] Load Locations');

export const loadLocationsSuccess = createAction(
  '[Locations] Load Locations Success',
  props<{ locations: LocationInterfaceWithId[] }>()
);

export const loadLocationsFailure = createAction(
  '[Locations] Load Locations Failure',
  props<{ error: any }>()
);

// ADD Locations
export const addLocation = createAction(
  '[Locations] add Location',
  props<{ location: LocationInterfaceWithId }>()
);


export const addLocationSuccess = createAction(
  '[Locations] added Location with success',
  props<any>()
);

export const addLocationError = createAction(
  '[Locations] added Location failed',
  props<{ error: Error }>()
);


// REMOVE Location
export const removeLocation = createAction(
  '[Locations] removed',
  props<{
    id: string,
  }>()
);

export const removeLocationSuccess = createAction(
  '[Locations] removed with success',
  props<any>()
);

export const removeLocationError = createAction(
  '[Locations] removed failed',
  props<{ error: Error }>()
);


// UPDATE Locations
export const updateLocation = createAction(
  '[Locations] update',
  props<{
    id: string,
    changes: LocationInterfaceWithId
  }>()
);


export const updateLocationSuccess = createAction(
  '[Locations] update success',
  props<any>()
);

export const updateLocationsError = createAction(
  '[Locations] update failed',
  props<{ error: Error }>()
);


// FIRESTORE ACTIONS

export const queryFireStoreLocations = createAction(
  '[Locations] query staff',
  props<any>()
);


export const queryFireStoreLocationsError = createAction(
  '[Locations] error at query staff',
  props<{ error: Error }>()
);


export const fromFireStoreAddLocation = createAction(
  '[Locations] added by Firestore',
  props<{ location: LocationInterfaceWithId }>()
);

export const fromFireStoreModifyLocation = createAction(
  '[Locations] modified by Firestore',
  props<{ location: LocationInterfaceWithId }>()
);


export const fromFireStoreRemoveLocation = createAction(
  '[Locations] removed by Firestore',
  props<{
    id: string,
  }>()
);



